import React from 'react';
import ProfilePanel from '../../components/organisms/ProfilePanel/ProfilePanel';

const ProfileTemplate = ({
  profile,
  stats,
  recent,
  loading,
  saving,
  tab,
  onTabChange,
  formData,
  initialData,
  onProfileChange,
  onSaveProfile,
  onSavePassword,
  pwdError,
  onClose,
}) => {
  return (
    <ProfilePanel
      profile={profile}
      stats={stats}
      recent={recent}
      loading={loading}
      saving={saving}
      tab={tab}
      onTabChange={onTabChange}
      formData={formData}
      initialData={initialData}
      onProfileChange={onProfileChange}
      onSaveProfile={onSaveProfile}
      onSavePassword={onSavePassword}
      pwdError={pwdError}
      onClose={onClose}
    />
  );
};

export default ProfileTemplate;